import "./LegalDisclaimer.module.css";
import Header from "@/reusable_sections/Header";
import DisclaimerOverview from "./sections/DisclaimerOverview";
import FullDisclaimerContent from "./sections/FullDisclaimerContent";
import RelatedResources from "./sections/RelatedResources";
import Footer from "@/reusable_sections/Footer";
export default function LegalDisclaimerPage() {
  return <div>
      <Header />
      <DisclaimerOverview />
      <FullDisclaimerContent />
      <RelatedResources />
      <Footer />
    </div>;
}